import { render, staticRenderFns } from "./hotelDeatils.vue?vue&type=template&id=4b9fbcfa&scoped=true&"
import script from "./hotelDeatils.vue?vue&type=script&lang=js&"
export * from "./hotelDeatils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9fbcfa",
  null
  
)

export default component.exports